import { wencesApi } from "@/api/wencesApi";
import { checkAuthAction } from "../actions/check-auth.action";
import { syncI18nLocaleFromUser } from "@/i18n";
import canAccessUsersSettingsGuard from "./can-access-users-settings.guard";

/**
 * Perfil de usuario (referencia User): propio perfil o permisos de listado de usuarios.
 */
export default async function canViewUserProfileGuard(to, from, next) {
  const token = localStorage.getItem("token");
  if (!token) {
    next("/login");
    return;
  }

  try {
    const statusResp = await checkAuthAction();
    if (statusResp.transient) {
      syncI18nLocaleFromUser(undefined);
      next();
      return;
    }
    if (!statusResp.ok) {
      next("/login");
      return;
    }
    syncI18nLocaleFromUser(statusResp.user);
    if (statusResp.needsToAcceptTerms) {
      localStorage.setItem("pendingRoute", to.fullPath);
      next("/login");
      return;
    }

    const itemId = to.params.itemId;
    if (!itemId) {
      next("/dashboard");
      return;
    }

    const profileResponse = await wencesApi.get("/api/users/myprofile", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!profileResponse.data.ok) {
      next("/dashboard");
      return;
    }

    const myId = profileResponse.data.data?._id;
    if (myId && String(myId) === String(itemId)) {
      next();
      return;
    }

    await canAccessUsersSettingsGuard(to, from, next);
  } catch (error) {
    console.error("canViewUserProfileGuard:", error);
    next("/login");
  }
}
